class Entry {
  constructor(el, opt) {
    this.el = el;
    this.opt = opt || {};

    // DOMが読み込まれるまで待機してから初期化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init() {
    // IDとクラスの両方をチェック
    this.$target = $("." + this.el);

    if (this.$target.length > 0) {
      this.event();
    }
  }

  event() {
    const $target = this.$target;

    if ($target.length === 0) {
      return;
    }

    // ショートコードで取得したカスタムフィールドデータを確認
    // ポーリングで最大3秒間、archiveCustomFieldsが定義されるまで待つ
    let attempts = 0;
    const maxAttempts = 30;

    const checkArchiveCustomFields = () => {
      attempts++;

      try {
        if (
          typeof archiveCustomFields !== "undefined" &&
          archiveCustomFields !== null
        ) {
          this.initCustomFields(archiveCustomFields);
          return;
        }
      } catch (error) {
        // エラーは無視して続行
      }

      if (attempts < maxAttempts) {
        setTimeout(checkArchiveCustomFields, 100);
      } else {
        // データがなくてもフォームフィールドの検索は実行
        this.initFormFiltering();
      }
    };

    checkArchiveCustomFields();
  }

  initCustomFields(customFieldsData) {
    if (!customFieldsData || !Array.isArray(customFieldsData)) {
      return;
    }

    this.customFieldsData = customFieldsData;
    this.initFormFiltering();
  }

  initFormFiltering() {
    const $target = this.$target;

    // 応募種別のラジオボタンを探す
    const $applicationTypeRadios = $target.find(
      'input[type="radio"][name*="応募種別"], ' +
        'input[type="radio"][name*="application"], ' +
        'input[type="radio"][name*="type"]'
    );

    // 応募職種のセレクトボックスを探す（表示用 - CF7管理外）
    const $jobTypeSelect = $target.find(
      'select[name*="応募職種"], ' +
        'select[name*="job"], ' +
        'select[name*="職種"], ' +
        "#occupation, " +
        "select#occupation, " +
        'select[name="occupation-display"], ' +
        'select[name="occupation"], ' +
        'select[name*="occupation"]'
    );

    // CF7のhiddenフィールドと同期、バリデーション
    if ($jobTypeSelect.length > 0) {
      const $occupationHidden = $target.find('input[name="occupation"][type="hidden"]');
      const $form = $target.find('.wpcf7-form');
      
      if ($occupationHidden.length > 0) {
        const syncToHidden = () => {
          const selectedValue = $jobTypeSelect.val() || '';
          $occupationHidden.val(selectedValue);
        };
        $jobTypeSelect.on('change', syncToHidden);
        if ($form.length > 0) {
          $form.on('submit', function(e) {
            syncToHidden();
          });
          $(document).on('wpcf7beforesubmit', $form, function() {
            syncToHidden();
          });
        }
        setTimeout(syncToHidden, 100);
      }

      // バリデーション
      this.initJobTypeValidation($jobTypeSelect, $form);
    }

    // 生年月日フィールドの動的設定（20代が選択できるように）
    this.initBirthdayField($target);

    // URLパラメータから応募種別と応募職種を取得
    const urlParams = new URLSearchParams(window.location.search);
    const urlType = urlParams.get("type");
    const urlJob = urlParams.get("job");

    // 応募種別の選択が変更されたときの処理
    if ($applicationTypeRadios.length > 0 && $jobTypeSelect.length > 0) {
      // カスタムフィールドデータがある場合のみ、フィルタリング機能を有効化
      if (
        this.customFieldsData &&
        Array.isArray(this.customFieldsData) &&
        this.customFieldsData.length > 0
      ) {
        $applicationTypeRadios.on("change", (e) => {
          const selectedType = $(e.target).val();
          this.updateJobTypeOptions(selectedType, $jobTypeSelect);
        });

        // URLパラメータがある場合は、それに基づいて選択
        if (urlType) {
          const $urlTypeRadio = $applicationTypeRadios.filter(
            `[value="${urlType}"]`
          );
          if ($urlTypeRadio.length > 0) {
            $urlTypeRadio.prop("checked", true);
            this.updateJobTypeOptions(urlType, $jobTypeSelect, urlJob);
          } else {
            // 初期状態で選択されている応募種別がある場合は、それに応じて応募職種を更新
            const $selectedType = $applicationTypeRadios.filter(":checked");
            if ($selectedType.length > 0) {
              const selectedType = $selectedType.val();
              this.updateJobTypeOptions(selectedType, $jobTypeSelect);
            } else {
              this.clearJobTypeOptions($jobTypeSelect);
            }
          }
        } else {
          // 初期状態で選択されている応募種別がある場合は、それに応じて応募職種を更新
          const $selectedType = $applicationTypeRadios.filter(":checked");
          if ($selectedType.length > 0) {
            const selectedType = $selectedType.val();
            this.updateJobTypeOptions(selectedType, $jobTypeSelect);
          } else {
            this.clearJobTypeOptions($jobTypeSelect);
          }
        }
      }
    }
  }

  updateJobTypeOptions(selectedType, $jobTypeSelect, preselectedJobId = null) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) {
      return;
    }

    if (!this.customFieldsData || !Array.isArray(this.customFieldsData)) {
      return;
    }

    // 応募種別とカスタムフィールドの親ターム名の対応関係
    const typeMapping = {
      新卒採用: "新卒採用",
      キャリア採用: "キャリア採用",
      インターンシップ: "インターンシップ",
    };

    // 選択された応募種別に対応する親ターム名を取得
    const mappedType = typeMapping[selectedType] || selectedType;
    const normalizeString = (str) => {
      if (!str) return "";
      return String(str).trim().toLowerCase();
    };

    const selectedTypeNormalized = normalizeString(mappedType);
    const originalTypeNormalized = normalizeString(selectedType);

    const selectedParent = this.customFieldsData.find((parent) => {
      const parentNameNormalized = normalizeString(parent.parent_term_name);
      const parentSlugNormalized = normalizeString(parent.parent_term_slug);

      // マッピング後の値で完全一致
      if (
        parentNameNormalized === selectedTypeNormalized ||
        parentSlugNormalized === selectedTypeNormalized
      ) {
        return true;
      }

      // 元の値でも完全一致を試す
      if (
        parentNameNormalized === originalTypeNormalized ||
        parentSlugNormalized === originalTypeNormalized
      ) {
        return true;
      }

      // 部分一致（どちらかが含まれている）
      if (
        parentNameNormalized.includes(selectedTypeNormalized) ||
        selectedTypeNormalized.includes(parentNameNormalized) ||
        parentSlugNormalized.includes(selectedTypeNormalized) ||
        selectedTypeNormalized.includes(parentSlugNormalized) ||
        parentNameNormalized.includes(originalTypeNormalized) ||
        originalTypeNormalized.includes(parentNameNormalized) ||
        parentSlugNormalized.includes(originalTypeNormalized) ||
        originalTypeNormalized.includes(parentSlugNormalized)
      ) {
        return true;
      }

      return false;
    });

    if (!selectedParent) {
      this.clearJobTypeOptions($jobTypeSelect);
      return;
    }

    // 既存の選択肢をクリア（全てクリア）
    $jobTypeSelect.empty();

    // 選択された応募種別に紐づく子ターム（応募職種）を取得
    if (selectedParent.children && Array.isArray(selectedParent.children)) {
      const addedDisplayNames = new Set(); // 重複チェック用
      const options = []; // 追加する選択肢を一時的に保存

      selectedParent.children.forEach((child) => {
        // 投稿がある子タームのみを表示
        if (
          child.posts &&
          Array.isArray(child.posts) &&
          child.posts.length > 0
        ) {
          // 各投稿のdisplay_nameを使用して選択肢を作成（【小要素名】recruit_titleの形式）
          child.posts.forEach((post) => {
            // display_nameが存在する場合はそれを使用、ない場合は生成
            const displayName =
              post.display_name ||
              `【${child.child_term_name}】${post.recruit_title || ""}`;

            // 重複を避ける
            if (!addedDisplayNames.has(displayName)) {
              addedDisplayNames.add(displayName);

              // CF7のメール返信文で使用するため、value属性にdisplay_nameを設定
              // タームIDもdata属性として保持（必要に応じて使用可能）
              const optionValue = displayName;

              const option = $("<option></option>")
                .attr("value", optionValue)
                .text(displayName)
                .data("term-id", child.child_term_id)
                .data("term-slug", child.child_term_slug)
                .data("category-color", child.category_color)
                .data("display-name", displayName)
                .data("grandchild-term-id", post.grandchild_term_id || 0)
                .data("grandchild-term-name", post.grandchild_term_name || "")
                .data("recruit-title", post.recruit_title || "");

              options.push(option);
            }
          });
        }
      });

      // 選択肢がある場合
      if (options.length > 0) {
        // プレースホルダーを追加
        $jobTypeSelect.append('<option value="">選択してください</option>');
        // 選択肢を追加
        options.forEach((option) => {
          $jobTypeSelect.append(option);
        });

        // URLパラメータで指定された応募職種を選択
        if (preselectedJobId) {
          const jobId = String(preselectedJobId);

          // まず、value属性で直接マッチングを試す（display_nameの場合）
          let $preselectedOption = $jobTypeSelect.find(
            `option[value="${jobId}"]`
          );

          // マッチしない場合、タームIDからdisplay_nameを探す
          if ($preselectedOption.length === 0) {
            // カスタムフィールドデータから該当する投稿を探す
            let targetDisplayName = null;

            if (
              selectedParent.children &&
              Array.isArray(selectedParent.children)
            ) {
              selectedParent.children.forEach((child) => {
                if (child.posts && Array.isArray(child.posts)) {
                  child.posts.forEach((post) => {
                    // タームIDが一致する投稿を探す
                    if (
                      String(post.grandchild_term_id) === jobId ||
                      String(child.child_term_id) === jobId
                    ) {
                      targetDisplayName =
                        post.display_name ||
                        `【${child.child_term_name}】${
                          post.recruit_title || ""
                        }`;
                    }
                  });
                }
              });
            }

            // display_nameが見つかった場合、それで選択
            if (targetDisplayName) {
              $preselectedOption = $jobTypeSelect.find(
                `option[value="${targetDisplayName.replace(/"/g, "&quot;")}"]`
              );
            }
          }

          if ($preselectedOption.length > 0) {
            $jobTypeSelect.val($preselectedOption.attr("value"));
          }
        }
      } else {
        // 選択肢が1つもない場合
        $jobTypeSelect.append('<option value="">募集要項がありません</option>');
      }
    } else {
      // 子タームが存在しない場合
      $jobTypeSelect.append('<option value="">募集要項がありません</option>');
    }

    // CF7のhiddenフィールドに同期（選択肢更新後）
    setTimeout(() => {
      this.syncToHiddenField($jobTypeSelect);
    }, 50);
  }

  clearJobTypeOptions($jobTypeSelect) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) return;

    $jobTypeSelect.empty();
    $jobTypeSelect.append(
      '<option value="">応募種別を選択してください</option>'
    );

    // CF7のhiddenフィールドに同期
    this.syncToHiddenField($jobTypeSelect);
  }

  // CF7のhiddenフィールドに同期する関数
  syncToHiddenField($jobTypeSelect) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) return;
    
    const selectedValue = $jobTypeSelect.val() || '';
    const $occupationHidden = $jobTypeSelect.closest('.wpcf7-form, .entry, body').find('input[name="occupation"][type="hidden"]');
    if ($occupationHidden.length > 0) {
      $occupationHidden.val(selectedValue);
    }
  }

  // 応募職種のバリデーション
  initJobTypeValidation($jobTypeSelect, $form) {
    const invalidValues = ['', '選択してください', '募集要項がありません'];
    let hasInteracted = false; // ユーザーが操作したかどうかのフラグ
    
    const validate = (showError = true, forceShow = false) => {
      const value = $jobTypeSelect.val() || '';
      const text = $jobTypeSelect.find('option:selected').text().trim();
      
      if (!value || invalidValues.includes(value) || invalidValues.includes(text)) {
        // エラーメッセージを表示する条件: 強制表示または（エラー表示が有効でユーザーが操作した場合）
        if (showError && (forceShow || hasInteracted)) {
          // エラーメッセージを表示する親要素を探す
          let $wrap = $jobTypeSelect.closest('.wpcf7-form-control-wrap');
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.closest('label');
          }
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.closest('p');
          }
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.parent();
          }
          
          // 既存のエラーメッセージを削除してから新しく作成
          $wrap.find('.wpcf7-not-valid-tip').remove();
          
          const $error = $('<span class="wpcf7-not-valid-tip"></span>');
          $wrap.append($error);
          $error.text('選択してください。').css({
            'color': 'red',
            'font-size': '1.4rem',
            'display': 'block',
            'margin-top': '0.5rem'
          });
          $jobTypeSelect.addClass('wpcf7-not-valid');
          
          // フォーカスを当てる
          setTimeout(() => {
            if ($jobTypeSelect[0]) {
              $jobTypeSelect[0].focus();
            }
          }, 100);
        }
        return false;
      } else {
        // エラーメッセージを非表示
        let $wrap = $jobTypeSelect.closest('.wpcf7-form-control-wrap, label, p');
        if ($wrap.length === 0) $wrap = $jobTypeSelect.parent();
        $wrap.find('.wpcf7-not-valid-tip').hide();
        $jobTypeSelect.removeClass('wpcf7-not-valid');
        return true;
      }
    };

    // 選択変更時（間違ったものを選んだ時も含む）
    $jobTypeSelect.on('change', function() {
      hasInteracted = true;
      validate(true, false); // エラーメッセージを表示
    });
    
    // フォーム送信時のバリデーション
    const $target = $jobTypeSelect.closest('.entry, .wpcf7, body');
    
    // 送信ボタンのクリックイベントをフック（複数の方法で確実に）
    const handleSubmit = function(e) {
      const isValid = validate(true, true); // 強制表示
      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
      }
    };
    
    // ネイティブイベント（キャプチャフェーズ）
    const $submitBtn = $target.find('.wpcf7-submit');
    if ($submitBtn.length > 0) {
      $submitBtn.each(function() {
        this.addEventListener('click', handleSubmit, true);
      });
    }
    
    // jQueryでもフック（委譲イベントで動的に追加される要素にも対応）
    $target.on('click', '.wpcf7-submit', handleSubmit);
    
    // フォーム送信イベントもフック
    if ($form.length > 0) {
      $form.on('submit', handleSubmit);
      $(document).on('wpcf7beforesubmit', $form, function(e) {
        const isValid = validate(true, true);
        if (!isValid) {
          e.preventDefault();
          return false;
        }
      });
    }
    
    // 動的に追加される送信ボタンにも対応（MutationObserverまたは定期的なチェック）
    const checkSubmitButton = () => {
      const $newSubmitBtn = $target.find('.wpcf7-submit').not('[data-validation-bound]');
      if ($newSubmitBtn.length > 0) {
        $newSubmitBtn.each(function() {
          $(this).attr('data-validation-bound', 'true');
          this.addEventListener('click', handleSubmit, true);
        });
      }
    };
    
    // 定期的にチェック（動的に追加されるボタンに対応）
    setInterval(checkSubmitButton, 500);
    setTimeout(checkSubmitButton, 1000);
  }

  // 生年月日フィールドの動的設定（20代が選択できるように）
  initBirthdayField($target) {
    // 生年月日フィールドを探す
    const $birthdayField = $target.find(
      'input[type="date"][name*="birthday"], ' +
      'input[type="date"][name="birthday"]'
    );

    if ($birthdayField.length === 0) {
      return;
    }

    // 今日の日付を取得
    const today = new Date();
    
    // 20代の範囲を計算
    // 最大値: 今日の日付
    const maxDate = new Date(today);
    
    // 最小値: 今日から100年前の01月01日（カレンダーで過去方向に100年遡れるように）
    const minDate = new Date(today);
    minDate.setFullYear(today.getFullYear() - 100);
    minDate.setMonth(0); // 0 = 1月
    minDate.setDate(1); // 1日

    // カレンダーを開いたときの初期表示位置: 20年前の01月01日
    const initialViewDate = new Date(today);
    initialViewDate.setFullYear(today.getFullYear() - 20);
    initialViewDate.setMonth(0); // 0 = 1月
    initialViewDate.setDate(1); // 1日

    // YYYY-MM-DD形式に変換
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const maxDateStr = formatDate(maxDate);
    const minDateStr = formatDate(minDate);
    const initialViewDateStr = formatDate(initialViewDate);

    // 各生年月日フィールドに設定
    $birthdayField.each(function() {
      const $field = $(this);
      const fieldElement = this;
      $field.attr('max', maxDateStr);
      $field.attr('min', minDateStr);

      // カレンダーを開いたときに20年前の1月1日が表示されるように設定
      let isInitializing = false;

      // フィールドがクリックされたとき（カレンダーを開く前）
      $field.on('mousedown', function(e) {
        if (!$field.val() && !isInitializing) {
          isInitializing = true;
          // 一時的に初期表示用の日付を設定
          $field.val(initialViewDateStr);
          // カレンダーが開いた後に、値が選択されていない場合はクリア
          setTimeout(() => {
            if ($field.val() === initialViewDateStr) {
              // ユーザーが何も選択していない場合、値をクリア
              // ただし、カレンダーが開いている間は値を保持
              const checkValue = setInterval(() => {
                if (!$field.is(':focus') && $field.val() === initialViewDateStr) {
                  $field.val('');
                  clearInterval(checkValue);
                  isInitializing = false;
                } else if ($field.val() !== initialViewDateStr) {
                  clearInterval(checkValue);
                  isInitializing = false;
                }
              }, 100);
              // 5秒後に強制的にクリア（安全策）
              setTimeout(() => {
                clearInterval(checkValue);
                if ($field.val() === initialViewDateStr && !$field.is(':focus')) {
                  $field.val('');
                }
                isInitializing = false;
              }, 5000);
            } else {
              isInitializing = false;
            }
          }, 200);
        }
      });

      // フォーカス時にも同様の処理（キーボード操作に対応）
      $field.on('focus', function() {
        if (!$field.val() && !isInitializing) {
          isInitializing = true;
          $field.val(initialViewDateStr);
          setTimeout(() => {
            if ($field.val() === initialViewDateStr) {
              const checkValue = setInterval(() => {
                if (!$field.is(':focus') && $field.val() === initialViewDateStr) {
                  $field.val('');
                  clearInterval(checkValue);
                  isInitializing = false;
                } else if ($field.val() !== initialViewDateStr) {
                  clearInterval(checkValue);
                  isInitializing = false;
                }
              }, 100);
              setTimeout(() => {
                clearInterval(checkValue);
                if ($field.val() === initialViewDateStr && !$field.is(':focus')) {
                  $field.val('');
                }
                isInitializing = false;
              }, 5000);
            } else {
              isInitializing = false;
            }
          }, 200);
        }
      });
    });
  }
}
class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const recruitSwiper = new Swiper(".recruit-swiper", {
      loop: true,
      slidesPerView: "1",
      centeredSlides: true,
      grabCursor: true,
      allowTouchMove: true,
      pagination: {
        el: ".recruit-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    // アーカイブページ用のスクロール機能
    if ($(".p-recruit-archive").length > 0) {
      this.initArchiveScroll();
    }
  }

  initArchiveScroll() {
    const $sideNavItems = $(".side-nav__item");
    const $archiveWrappers = $(".archive-main__wrapper");
    let isScrolling = false;
    let isInitializing = true; // 初期化中フラグ
    let userScrollTimeout = null; // ユーザースクロール完了判定用
    let clickedTargetId = null; // クリックされたターゲットIDを保持

    // スクロール完了後にis-activeを付与する関数
    const updateActiveOnScrollEnd = () => {
      if (isScrolling || isInitializing) {
        return;
      }

      // クリックされたターゲットが指定されている場合、そのターゲットが正しく表示されているか確認
      // クリックしたターゲットが表示範囲内に到達するまで、クラスを変更しない
      if (clickedTargetId) {
        const $clickedTarget = $(clickedTargetId);
        if ($clickedTarget.length > 0) {
          const rect = $clickedTarget[0].getBoundingClientRect();
          const headerHeight = $(".l-header").outerHeight() || 0;
          const viewportTop = headerHeight + 50;
          
          // クリックしたターゲットが表示範囲内にある場合は、そのまま維持してリセット
          if (rect.top <= viewportTop + 100 && rect.bottom >= viewportTop) {
            clickedTargetId = null; // 確認完了したのでリセット
            return; // クラスは既に設定されているので更新不要
          }
        }
        // クリックしたターゲットがまだ表示範囲外の場合は、クラスを変更せずに終了
        // （下にスクロールする場合、途中で別のセクションに入ってもクラスを維持する）
        return;
      }

      const $activeSection = $archiveWrappers
        .filter(function () {
          const rect = this.getBoundingClientRect();
          const headerHeight = $(".l-header").outerHeight() || 0;
          const viewportTop = headerHeight + 50;
          return rect.top <= viewportTop + 100 && rect.bottom >= viewportTop;
        })
        .first();

      if ($activeSection.length > 0) {
        const activeId = $activeSection.attr("id");
        $sideNavItems.removeClass("is-active");
        $sideNavItems
          .find(`a[href="#${activeId}"]`)
          .closest(".side-nav__item")
          .addClass("is-active");
      }
    };

    // スクロールイベントを監視して、スクロール完了後にis-activeを付与
    $(window).on("scroll", () => {
      // クリックされたターゲットが設定されている場合は、スクロールイベントによる更新をスキップ
      if (clickedTargetId) {
        return;
      }

      // スクロール中フラグを立てる
      isScrolling = true;

      // 既存のタイマーをクリア
      clearTimeout(userScrollTimeout);

      // スクロールが止まってから一定時間後にis-activeを付与
      userScrollTimeout = setTimeout(() => {
        // 再度clickedTargetIdをチェック（クリック中に変更された可能性があるため）
        if (clickedTargetId) {
          return;
        }
        isScrolling = false;
        updateActiveOnScrollEnd();
      }, 150); // 150msスクロールが止まったら完了とみなす
    });

    // アンカーリンクのクリックイベント（ブラウザ標準のアンカー遷移を使用）
    $sideNavItems.find("a").on("click", function () {
      const targetId = $(this).attr("href");
      const $target = $(targetId);
      const $clickedItem = $(this).closest(".side-nav__item");

      if ($target.length > 0) {
        clearTimeout(userScrollTimeout);
        clickedTargetId = targetId;
        $sideNavItems.removeClass("is-active");
        $clickedItem.addClass("is-active");
        isScrolling = true;
        // 標準のアンカー遷移に任せ、一定時間後にフラグを解除してスクロール監視を再開
        setTimeout(() => {
          clickedTargetId = null;
          isScrolling = false;
          updateActiveOnScrollEnd();
        }, 500);
      }
    });

    // 初期状態で最初のセクションが表示されている場合の処理
    const checkInitialActive = () => {
      // 初期化中フラグを立てる（IntersectionObserverを無効化）
      isInitializing = true;

      // まず最初のナビゲーション項目にis-activeを付与
      const $firstNavItem = $sideNavItems.first();
      if ($firstNavItem.length > 0) {
        $sideNavItems.removeClass("is-active");
        $firstNavItem.addClass("is-active");
      }

      // その後、実際に表示されているセクションを確認して更新
      $archiveWrappers.each(function () {
        const rect = this.getBoundingClientRect();
        const headerHeight = $(".l-header").outerHeight() || 0;
        const viewportTop = headerHeight + 50; // 50pxの余白
        const viewportBottom = window.innerHeight * 0.6;

        if (
          rect.top <= viewportTop + 100 &&
          rect.bottom >= viewportTop &&
          rect.top <= viewportBottom
        ) {
          const targetId = $(this).attr("id");
          $sideNavItems.removeClass("is-active");
          $sideNavItems
            .find(`a[href="#${targetId}"]`)
            .closest(".side-nav__item")
            .addClass("is-active");
          return false;
        }
      });

      // 初期化完了後、少し遅延してからフラグを解除
      setTimeout(() => {
        isInitializing = false;
      }, 500);
    };

    // ページ読み込み時に初期状態をチェック
    // DOMContentLoadedとwindow.loadの両方で実行して確実に初期化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", checkInitialActive);
    } else {
      checkInitialActive();
    }

    // ウィンドウ読み込み完了後にも確認（レイアウトが確定した後）
    $(window).on("load", () => {
      setTimeout(checkInitialActive, 100);
    });
  }
}
class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // fix-logoの高さを取得してCSS変数に設定
    this.setFixLogoHeight();
    
    const mvSwiper = new Swiper(".mv__swiper", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 25,
      speed: 7500,
      allowTouchMove: false,
      centeredSlides: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });

    const peopleSwiper = new Swiper(".people-swiper", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: true,
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      },
    });

    // Culture section image hover
    this.initCultureImageHover();
  }

  setFixLogoHeight() {
    const $fixLogo = $(".fix-logo");
    if ($fixLogo.length === 0) return;

    const updateHeight = () => {
      const $img = $fixLogo.find("img");
      if ($img.length > 0) {
        // 画像の読み込み完了を待つ
        if ($img[0].complete) {
          const height = $img[0].offsetHeight;
          $fixLogo[0].style.setProperty("--fix-logo-height", `${height}px`);
        } else {
          $img.on("load", function() {
            const height = this.offsetHeight;
            $fixLogo[0].style.setProperty("--fix-logo-height", `${height}px`);
          });
        }
      }
    };

    // 初期実行
    updateHeight();

    // リサイズ時にも更新
    $(window).on("resize", updateHeight);
  }

  initCultureImageHover() {
    const $hoverLinks = $(".js-culture-hover");
    const $image = $(".js-culture-image");
    const $imageSource = $(".js-culture-image-source");
    const defaultImagePc = $image.attr("src");
    const defaultImageSp = $imageSource.attr("srcset");

    if ($hoverLinks.length === 0 || $image.length === 0) {
      return;
    }

    // PC版のみ画像切り替えを有効化（768px以下では無効）
    const isMobile = () => window.innerWidth <= 768;

    // 画像にトランジション用のCSSを適用（PC版のみ）
    if (!isMobile()) {
      $image.css({
        'transition': 'opacity 0.3s linear'
      });
    }

    // 現在表示されている画像のパスを保持
    let currentImagePc = defaultImagePc;

    $hoverLinks.on("mouseenter", function () {
      // スマートフォンでは画像を切り替えない
      if (isMobile()) {
        return;
      }

      const $this = $(this);

      // is-activeクラスが付いている場合はエフェクトをスキップ
      if ($this.hasClass('is-active')) {
        return;
      }

      // 他の要素からis-activeクラスを削除
      $hoverLinks.removeClass('is-active');
      
      // 現在の要素にis-activeクラスを付与
      $this.addClass('is-active');

      // is-activeが付いている要素の画像を表示
      const imagePc = $this.data("image-pc");

      // 既に表示されている画像の場合はエフェクトをスキップ
      if (imagePc && imagePc === currentImagePc) {
        return;
      }

      if (imagePc) {
        // フェードアウト → 画像変更 → フェードイン
        $image.css('opacity', '0');
        
        setTimeout(() => {
          $image.attr("src", imagePc);
          currentImagePc = imagePc; // 現在の画像を更新
          
          // 画像読み込み完了後にフェードイン
          $image.on('load', function() {
            $(this).css('opacity', '1');
          }).each(function() {
            // 既にキャッシュされている画像の場合、loadイベントが発火しないため
            if (this.complete) {
              $(this).css('opacity', '1');
            }
          });
        }, 150); // フェードアウトの半分の時間で画像を切り替え
      }
    });

    // is-activeが付いている要素の画像を常に表示する関数
    const updateImageForActive = () => {
      const $activeLink = $hoverLinks.filter('.is-active');
      
      if ($activeLink.length > 0) {
        const imagePc = $activeLink.data("image-pc");
        
        if (imagePc && imagePc !== currentImagePc) {
          // フェードアウト → 画像変更 → フェードイン
          $image.css('opacity', '0');
          
          setTimeout(() => {
            $image.attr("src", imagePc);
            currentImagePc = imagePc; // 現在の画像を更新
            
            // 画像読み込み完了後にフェードイン
            $image.on('load', function() {
              $(this).css('opacity', '1');
            }).each(function() {
              // 既にキャッシュされている画像の場合、loadイベントが発火しないため
              if (this.complete) {
                $(this).css('opacity', '1');
              }
            });
          }, 150);
        }
      } else {
        // is-activeが付いている要素がない場合はデフォルト画像に戻す
        if (currentImagePc !== defaultImagePc) {
          // フェードアウト → 画像変更 → フェードイン
          $image.css('opacity', '0');
          
          setTimeout(() => {
            $image.attr("src", defaultImagePc);
            currentImagePc = defaultImagePc; // 現在の画像を更新
            
            // 画像読み込み完了後にフェードイン
            $image.on('load', function() {
              $(this).css('opacity', '1');
            }).each(function() {
              // 既にキャッシュされている画像の場合、loadイベントが発火しないため
              if (this.complete) {
                $(this).css('opacity', '1');
              }
            });
          }, 150);
        }
      }
    };

    $hoverLinks.on("mouseleave", function () {
      // スマートフォンでは画像を切り替えない
      if (isMobile()) {
        return;
      }

      // マウスリーブ時はis-activeを削除せず、そのまま維持
      // is-activeが付いている要素の画像を常に表示する
      updateImageForActive();
    });
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class Header {
  constructor() {
    this.event();
  }
  event() {
    // ハンバーガーメニューのクリックイベント
    $(".hamburger-btn").click(function () {
      $(".l-header").toggleClass("is-active");
      $("body").toggleClass("is-fixed");
    });

    // トップページ判定とクラス付与
    function setHeaderTopClass() {
      if ($('.p_top').length > 0) {
        $(".l-header").addClass("p-top");
      } else {
        $(".l-header").removeClass("p-top");
      }
    }

    // DOM読み込み後に実行
    $(document).ready(function() {
      setHeaderTopClass();
    });

    // スクロールイベント
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 50) {
        $(".l-header").addClass("scroll-active");
      } else {
        $(".l-header").removeClass("scroll-active");
      }
    });
  }
}


// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBanOpen();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBanClase();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  // スクロール禁止
  if(body.classList.contains('is-hidden')){
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
    $('html').css({'scroll-behavior': 'smooth'})
  } else {
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
    $('html').css({'scroll-behavior': 'inherit'})
  }
}
class TopElementor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-elementor-drawer-trigger').on('click', function(){
      $('html').toggleClass('is-elementor-drawer-open');
      scrollBan();
    });

    let scrollTimer;
    $(window).on('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        if($(window).scrollTop() > 100) {
          $('html').addClass('is-scroll');
        } else {
          $('html').removeClass('is-scroll');
        }
      }, 100);
    });

  }
}


// ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
window.addEventListener("load", () => {
  setTimeout(() => {
    $(".js-loading").fadeOut();
  }, 1500);
});

(() => {
  let imgParallax = new ImgParallax("js-parallax");
  let inviewEvent = new InviewEvent("js-inview");

  // ------------------------------
  // 共通機能（全ページで適用）
  // ------------------------------
  let header = new Header();

  // ------------------------------
  // トップページ用
  // ------------------------------
  let top = new Top("p_top");

  // ------------------------------
  // エントリーページ用
  // ------------------------------
  let entry = new Entry("p-entry-form");

  // ------------------------------
  // 募集要項ページ用
  // ------------------------------
  let recruit = new Recruit("p-recruit-info");

  // ------------------------------
  // 募集要項アーカイブページ用
  // ------------------------------
  let recruitArchive = new Recruit("p-recruit-archive");

  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let topElementor = new TopElementor("js-topElementor");
  let modal = new Modal("js-modal");
  let accordion = new Accordion("js-accordion");
  let editor = new Editor("c-content");
})();

//DOMContentLoaded
$(() => {});

//images resources loaded
$(window).on("load", () => {
  $(window).trigger("loading");
});

//after loading animation
$(window).on("loading", () => {});